var PES = PES || {};
PES.Home = function () {

	function setupDemo() {
        // change image when clicking on buttons with icons
        // Imagine building stunning project visuals effortlessly.
        const demoImg = $('.js-demo-image');
        const demoImgSrc = $(demoImg).attr('src');
        const demoImgAlt = $(demoImg).attr('alt');

        const demoButtons = $('.js-demo-nav a');

        var rollbackImage;

        function revertDemoImageSource() {
            $(demoImg)
                .attr('src', demoImgSrc)
                .attr('alt', demoImgAlt);
        }

        function revertAction() {
            rollbackImage = setTimeout(revertDemoImageSource, 1500);
        }

        function clearTimelapse() {
            clearTimeout(rollbackImage);
        }

        demoButtons.each(function (index) {
            $(this).on('click', function (e) {
                e.preventDefault();
                const imgSrc = $(this).data('src');
                const imgAlt = $(this).data('alt');

                $(demoImg)
                    .attr('src', imgSrc)
                    .attr('alt', imgAlt);
                clearTimelapse();
                revertAction();
            });
        });
    };

	var init = function () {
		setupDemo();
	};

	return {
		init: init
	};
}();
